import React, { useState, useEffect, useRef, createContext, useContext, useCallback, useMemo } from 'react';
import { MessageSquare, Send, X, Phone, Video, Minimize, Maximize, ChevronUp, MessageSquareText, Settings, UserRound } from 'lucide-react';
import axiosInstance from './network';
import moment from 'moment';
import { io } from "socket.io-client";

// Create a context for the chat state
const ChatContext = createContext();

// Custom hook to use the chat context
export const useChatContext = () => useContext(ChatContext);


// Chat Provider Component
export const ChatProvider = ({ children }) => {
    const [activeChats, setActiveChats] = useState([]);
    const [activeChatsIds, setActiveChatsIds] = useState({});
    const [activeChatsMsg, setActiveChatsMsg] = useState({});
    const [openChatUserId, setOpenChatUserId] = useState(0)
    // console.log('activeChatsactiveChatsactiveChats', activeChats)

    const [minimizedChats, setMinimizedChats] = useState([]);




    const [minimizedContact, setMinimizedContact] = useState(true);
    const [newMessage, setNewMessage] = useState({});
    const [searchContactVal, setSearchContactVal] = useState("");
    const [searchVal, setSearchVal] = useState("");


    const textareaRef = useRef({});

    const messageEndRef = useRef({});
    // const MAX_CHATS = 3;
    const [activeTab, setActiveTab] = useState('chat');
    const [maxChat, setMaxChat] = useState(3)

    // State to hold the chat user list
    const [userList, setUserList] = useState([]);
    // State to hold the chat user list
    const [contactList, setContactList] = useState([]);
    const [ContactListSearch, setContactListSearch] = useState([]);
    const [chatListSearch, setChatListSearch] = useState([]);
    const [chatGroupMembers, setChatGroupMembers] = useState([])

    // State messages list
    const [messages, setMessages] = useState([])

    // state message input
    const [message, setMessage] = useState('')
    // state for chatid

    const [chatId, setChatId] = useState('')
    const [chats, setChats] = useState({})
    const [toUser, setToUser] = useState("")
    const [socket, setSocket] = useState(null);
    const [messageAlert, setMessageAlert] = useState(false)
    const [messageWorkchatAlert, setMessageWorkchatAlert] = useState(false)
    const [messageWorkchatUserAlert, setMessageWorkchatUserAlert] = useState(false)
    const [updateUserListNotification, setUpdateUserListNotification] = useState(false)


    const activeChatRef = useRef(activeChats);
    const userChatRef = useRef(userList);
    const messageAlertRef = useRef(messageAlert);




    // FileUpload

    const [fileToUpload, setFileToUpload] = useState(null);
    const [showPreviewDialog, setShowPreviewDialog] = useState(false);
    const fileInputRef = useRef(null);
    const dropAreaRef = useRef(null);
    const [fileUrl, setFileUrl] = useState("")
    const [isDragging, setIsDragging] = useState(false);
    const [activeGroupChat, setActiveGroupChat] = useState("")
    const [activeBotChat, setActiveBotChat] = useState("")
    const [activeUserChat, setActiveUserChat] = useState("")


    // reply message

    const [replyMessageData, setReplyMessageData] = useState('')
    const messagesContainerRef = useRef(null);

    const [highlightReply, setHighlightReply] = useState('')


    // menton states
    const groupInputRef = useRef(null);
    const modalRef = useRef(null);


    const [showModal, setShowModal] = useState(false);
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0, width: 0 });
    const [mentionQuery, setMentionQuery] = useState('');
    const [mentionedUsers, setMentionedUsers] = useState([]);
    const filteredMentionGroupMembers = chatGroupMembers.filter(contact =>
        contact.userId.name.toLowerCase().includes(mentionQuery.toLowerCase())
    );

    const [activeChatOptions, setActiveChatOptions] = useState('All');
    const [isDisableMcpInput, setIsDisableMcpInput] = useState(false)

    const [chatPageLimit, setChatPageLimit] = useState(0)
    const [clickedAkc, setClickedAkc] = useState(false);


    const handleChatFilter = val => {

        setActiveChatOptions(val)
        fetchChatUserList(val)
        setActiveBotChat("")
        setSearchVal("")
        closeChat(openChatUserId)
        // toggleMinimize


    }

    // Cancel file upload
    const handleCancelFileUpload = () => {
        setFileToUpload(null);
        setShowPreviewDialog(false);
        fileInputRef.current.value = '';

        setNewMessage(prev => ({ ...prev, [toUser]: "" }));

    };

    // Trigger file input click
    const handleAttachmentClick = (id) => {
        setToUser(id)
        fileInputRef.current.click();
    };

    // Check if file is an image
    const isImageFile = (file) => {
        return file && file.type.startsWith('image/');
    };

    // Format file size
    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        else return (bytes / 1048576).toFixed(1) + ' MB';
    };


    // FILE UPLOAD FUNCTIONS

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    }, []);

    const handleDragEnter = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    }, []);

    const handleDragLeave = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    }, []);

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const file = e.dataTransfer.files[0];
            setFileToUpload(file);
            setShowPreviewDialog(true);
        }
    }, []);


    const handleFileSelect = (e) => {
        if (e.target.files.length > 0) {
            const file = e.target.files[0];
            setFileToUpload(file);
            setShowPreviewDialog(true);
        }
    };


    // const fetchUploadFileApi = async (file) => {
    //     try {
    //         var formData = new FormData();
    //         formData.append("files", fileToUpload);
    //         // const response = axiosInstance.post('chatFile/fileUpload', payload)
    //         const response = await axiosInstance.post(
    //             `chatFile/fileUpload`,
    //             formData,
    //             {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                 },
    //             }
    //         );
    //         if (response.data.status === 'success') {
    //             console.log('fetchUploadFileApi', response.data)
    //             setFileUrl(response.data.url)
    //             setNewMessage(prev => ({ ...prev, [toUser]: fileToUpload.name, }));
    //         }
    //     } catch (error) {

    //     }

    // }
    const [isUploadFileLoading, setIsUploadFileLoading] = useState(false)

    const fetchUploadFileApi = async () => {
        setIsUploadFileLoading(true)
        try {
            const uploadedUrls = [];
            const farr = [fileToUpload]
            const uploadTasks = farr.map(async (file) => {
                // 1. Get presigned URL
                const preSendResponse = await axiosInstance.post(
                    `chatFile/filepresignedUpload`,
                    { fileName: file.name, fileType: file.type }
                );

                const { presignedUrl, fileUrl } = preSendResponse.data;

                // 2. Upload to S3
                const uploadToS3 = await fetch(presignedUrl, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/octet-stream",
                    },
                    body: file,
                });

                if (uploadToS3.status === 200) {
                    uploadedUrls.push(fileUrl);
                } else {
                    console.error("Failed upload:", file.name, uploadToS3.status);
                }
            });

            // Run all uploads in parallel
            await Promise.all(uploadTasks);

            // 3. Update state after uploads
            setFileUrl(uploadedUrls[0]);
            setNewMessage(prev => ({ ...prev, [toUser]: fileToUpload.name, }));

        } catch (error) {
            console.log("Upload failed:", error);
        } finally {
            setIsUploadFileLoading(false)
        }
    };




    useEffect(() => {
        activeChatRef.current = activeChats;
    }, [activeChats]);
    useEffect(() => {
        userChatRef.current = userList;
        if (userList.length > 0) {
            localStorage.setItem('userListStore', JSON.stringify(userList));
        }
    }, [userList]);
    useEffect(() => {
        messageAlertRef.current = messageAlert;
    }, [messageAlert]);
    const handleSwitchTab = (event) => {
        setActiveTab(event);
        setActiveChatOptions('All')
        if (event === "contact") {
            fetchContacts()

        } else {
            fetchChatUserList()
        }
    };

    // Fetches the full user list
    const fetchChatUserList = async (val) => {
        // setIsLoading(true)
        try {
            const response = await axiosInstance.get("chatUser/userList");

            if (response.data.status === "success") {
                const users = response.data.response;

                let filteredUsers = users;

                if (val === "Groups") {
                    filteredUsers = users.filter(x => x.type === "group");
                } else if (val === "Unread") {
                    filteredUsers = users.filter(x => x.unReadCount > 0);
                } else if (val === "AI") {
                    filteredUsers = users.filter(x => x.type === "bot");
                } else if (val === "Broadcasts") {
                    filteredUsers = users.filter(x => x.type === "broadcast");
                }



                setUserList(filteredUsers);
                // setUserList(response.data.response);
                setChatListSearch(users);
            }
        } catch (error) {
            console.error("fetchChatUserList error:", error);
        } finally {
            // setIsLoading(false)
        }
    };


    // Fetches the user list based on the search input

    const fetchSearchChatUserList = async () => {
        const trimmedVal = searchVal.trim();

        if (trimmedVal.length === 0) {
            fetchChatUserList();
            return;
        }

        try {
            const response = await axiosInstance.post("chatUser/search", {
                name: trimmedVal,
            });

            console.log("fetchSearchChatUserList", response.data);

            if (response.data.status === "success") {
                setUserList(response.data.userList || []);
            }
        } catch (error) {
            console.error("fetchSearchChatUserList error:", error);
        }
    };

    // Fetches all contacts list

    const fetchContacts = async () => {
        try {
            const response = await axiosInstance.get(`chatUser/contactList`)

            console.log('fetchContacts', response.data)
            if (response.data.status === 'success') {
                setContactList(response.data.userData)
                setContactListSearch(response.data.userData)
            }

        } catch (error) {
            console.log('fetchContacts', error)

        } finally {
            // setIsLoading(false)
        }
    }



    const processChatHistory = (chatHistory, chatUserId, authuserId) => {
        const modifychat = chatHistory.map((msg) => {
            return {
                _id: msg._id,
                sender: msg.fromUserId._id !== authuserId ? 'reciver' : 'me',
                text: msg.messageContent,
                isRead: msg.isRead,
                user: msg.toUserId._id !== authuserId ? msg?.toUserId : msg?.fromUserId,
                time: moment(msg?.updatedAt).format('ddd hh:mm A'),
                type: msg?.messageType,
                link: msg?.fileUrl || "",
                fileType: msg?.fileType || "",
                createdAt: msg?.createdAt
            };
        });

        const grouped = {};
        modifychat.forEach((msg) => {
            const dateKey = moment(msg.createdAt).format("YYYY-MM-DD");
            if (!grouped[dateKey]) {
                grouped[dateKey] = [];
            }
            grouped[dateKey].push(msg);
        });

        const data = Object.keys(grouped)
            .sort((a, b) => moment(b).diff(moment(a)))
            .map((date) => {
                const mDate = moment(date);
                let label = mDate.isSame(moment(), "day")
                    ? "Today"
                    : mDate.isSame(moment().subtract(1, "day"), "day")
                        ? "Yesterday"
                        : mDate.format("DD MMM YYYY");

                return {
                    date: label,
                    chats: grouped[date],
                    chatUserId: chatUserId
                };
            });

        return data;
    };





    // Fetch chat history 
    // ✅ Add these state variables to your ChatProvider
    const [hasMoreMessages, setHasMoreMessages] = useState(true);
    const [hasMoreGroupMessages, setHasMoreGroupMessages] = useState(true);
    const hasMoreMessagesRef = useRef(true);
    const hasMoreGroupMessagesRef = useRef(true);

    // ✅ Fixed fetchChatHistory with cursor-based pagination
    // const fetchChatHistory = async (val, limit = 0) => {
    //     // ✅ Stop if no more messages available
    //     if (!hasMoreMessagesRef.current) {
    //         console.log('✋ No more messages to fetch');
    //         return;
    //     }

    //     try {
    //         // ✅ For cursor-based pagination: 
    //         // - First call: lastId = "" (gets most recent 20)
    //         // - Next calls: lastId = last message's _id (gets next 20 older messages)
    //         const lastMessageId = (limit !== 0 && messages.length > 0)
    //             ? messages[messages.length - 1]._id  // Get the OLDEST message (last in array)
    //             : "";

    //         const dada = {
    //             toUser: val,
    //             limit: 20,
    //             lastId: lastMessageId
    //         };

    //         console.log('📤 Fetching chat history:', {
    //             ...dada,
    //             currentMessagesCount: messages.length,
    //             isFirstCall: limit === 0
    //         });

    //         const response = await axiosInstance.post("chatUser/chatHistory", dada);

    //         console.log('📥 fetchChatHistory response:', {
    //             status: response.data.status,
    //             receivedCount: response.data.chatHistory?.length || 0,
    //             chatUserId: response.data.chatUserId
    //         });

    //         if (response.data.status === "success") {
    //             const messageArr = response.data.chatHistory;

    //             // ✅ Check if we've reached the end (empty array returned)
    //             if (messageArr.length === 0) {
    //                 console.log('✅ No more messages available - end of pagination');
    //                 setHasMoreMessages(false);
    //                 hasMoreMessagesRef.current = false;
    //                 return;
    //             }

    //             // ✅ Check if we got fewer messages than requested (last page)
    //             // if (messageArr.length < 20) {
    //             //     console.log('✅ Last page reached - got', messageArr.length, 'messages');
    //             //     setHasMoreMessages(false);
    //             //     hasMoreMessagesRef.current = false;
    //             // }

    //             // ✅ Append older messages to the END of the array
    //             setMessages((prev) => [...prev, ...messageArr]);

    //             // Update chat IDs
    //             if (response.data.chatUserId && response.data.chatUserId !== "") {
    //                 setActiveChatsIds(prev => {
    //                     const existing = prev[val] || [];

    //                     // Avoid adding duplicate
    //                     if (existing.includes(response.data.chatUserId)) {
    //                         return prev;
    //                     }

    //                     return {
    //                         ...prev,
    //                         [val]: [...existing, response.data.chatUserId],
    //                     };
    //                 });
    //             }

    //             setChatPageLimit((prev) => prev + 1);
    //         }
    //     } catch (error) {
    //         console.error('❌ fetchChatHistory error:', error);
    //         // Don't block future fetches on error
    //     }
    // };

    // Fetch user chat history 
    const fetchChatHistory = async (val, limit = 0) => {
        try {

            let dada = {
                toUser: val,
                limit: 20,
                lastId: (limit !== 0) ? messages.at(-1)._id : null
            }

            const response = await axiosInstance.post("chatUser/chatHistory", dada);


            if (response.data.status === "success") {
                let messageArr = response.data.chatHistory

                if (response.data.chatUserId != "") {
                    // setChatId(response.data.chatUserId)
                    setActiveChatsIds(prev => {
                        const existing = prev[val] || [];

                        // Avoid adding duplicate
                        if (existing.includes(response.data.chatUserId)) {
                            return prev;
                        }

                        return {
                            ...prev,
                            [val]: [...existing, response.data.chatUserId],
                        };
                    });
                    // fetchChatMedia(response.data.chatUserId)
                }
                if (messageArr.length === 0) {
                    console.log('✅ No more messages available - end of pagination');
                    setHasMoreMessages(false);
                    hasMoreMessagesRef.current = false;
                    return;
                }
                setMessages((prev) => [...prev, ...messageArr]);




                setChatPageLimit((prev) => prev + 1);
            }
        } catch (error) {
            console.log('fetchGroupChatHistory', error)
        }
    }

    // Fetch group chat history 
    const fetchGroupChatHistory = async (val, limit = 0) => {
        try {

            let dada = {
                limit: 20,
                lastId: (limit !== 0) ? messages.at(-1)._id : null
            }

            const response = await axiosInstance.post(`/group/history/${val.chatUserId}`, dada);


            if (response.data.status === "success") {
                let messageArr = response.data.chatHistory

                setActiveChatsIds(val.chatUserId)
                if (messageArr.length === 0) {
                    console.log('✅ No more messages available - end of pagination');
                    setHasMoreMessages(false);
                    hasMoreMessagesRef.current = false;
                    return;
                }
                setMessages((prev) => [...prev, ...messageArr]);




                setChatPageLimit((prev) => prev + 1);
            }
        } catch (error) {
            console.log('fetchGroupChatHistory', error)
        }
    }

    // Fetch chat Group info
    const fetchChatGroupInfo = async (val) => {
        try {

            const response = await axiosInstance.get(`/group/groupInfo/${val}`);

            console.log('fetchChatGroupInfo', response.data)

            if (response.data.status === "success") {

                setChatGroupMembers(response.data.groupInfo.userList)

            } else {
                setChatGroupMembers([])
            }

        } catch (error) {
            console.log('fetchChatGroupInfo', error)
        }
    }

    const fetchBotChatHistory = async (val, limit = 0) => {
        try {


            let dada = {
                limit: 20,
                lastId: (limit !== 0) ? messages.at(-1)._id : null
            }

            const response = await axiosInstance.post(`/bot/chatHistory/${val.chatUserId}`, dada);

            // const response = await axiosInstance.get(`/bot/chatHistory/${val.chatUserId}`);

            console.log('fetchBotChatHistory', response.data)

            if (response.data.status === "success") {
                let messageArr = response.data.chatList
                if (messageArr.length === 0) {
                    console.log('✅ No more messages available - end of pagination');
                    setHasMoreMessages(false);
                    hasMoreMessagesRef.current = false;
                    return;
                }
                setMessages(messageArr)
                if (response.data?.hasMcp) {
                    setIsDisableMcpInput(true)
                } else {
                    setIsDisableMcpInput(false)

                }
                setChatPageLimit((prev) => prev + 1);

            }
        } catch (error) {
            console.log('fetchBotChatHistory', error)
        }
    }

    // read bot message api 
    const fetchReadBotMessage = async (val) => {
        try {



            const response = await axiosInstance.get(`bot/readBotMessage/${val}`);

            console.log('fetchChannelChatHistory', response.data)

            if (response.data.status === "success") {
                const newData = userChatRef.current.map(obj =>
                    obj.chatUserId === val
                        ? { ...obj, unReadCount: 0 }
                        : obj
                );

                const isEqual = JSON.stringify(userList) === JSON.stringify(newData); // or use deepEqual if needed

                userChatRef.current = newData;

                if (!isEqual) {
                    setUserList(newData);
                }
            }
        } catch (error) {
            console.log('fetchChannelChatHistory', error)
        }
    }



    useEffect(() => {
        const authuserId = localStorage.getItem("authUser");


        if (toUser === "") return


        let uu = activeChats.includes(toUser)
        const found = activeChats.find(id => id === toUser) || toUser


        const modifychat = messages.map((msg) => {
            const senderId = msg.fromUserId?._id || msg?.userId?._id;
            const isSender = senderId === authuserId;
            const user =
                msg.toUserId?._id !== authuserId ? msg.toUserId : msg.fromUserId;

            if (activeUserChat.type === "user") {
                return {
                    _id: msg._id,
                    sender: isSender ? "me" : "reciver",
                    text: msg.messageContent,
                    isRead: msg.isRead,
                    user,
                    time: moment(msg?.updatedAt).format("ddd hh:mm A"),
                    type: msg?.messageType,
                    link: msg?.fileUrl || "",
                    fileType: msg?.fileType || "",
                    createdAt: msg?.createdAt,
                    isForwarded: msg.isForwarded,
                    isDeleted: msg.isDeleted,
                    isStared: msg.isStared,
                    replyMessageId: msg.replyMessageId || "",
                    fileName: msg.fileName,
                    pollMessage: msg.pollMessage,
                    isBroadCastAcknowledge: msg?.isBroadCastAcknowledge,
                    broadCastMessageId: msg?.broadCastMessageId,

                };
            } else if (activeBotChat.type === "bot") {
                return {

                    _id: msg._id,
                    // groupId: msg.groupId,
                    sender: msg.messageType === ('M' || "AI" || "doc" || 'cta') ? "me" : "reciver",
                    text: msg.messageContent,
                    // isRead: msg.isRead,
                    // user,
                    time: moment(msg?.updatedAt).format("ddd hh:mm A"),
                    type: msg?.messageType,
                    link: msg?.fileUrl || "",
                    fileType: msg?.fileType || "",
                    createdAt: msg?.createdAt,
                    // name: msg?.userId?.name,
                    ctaInfo: msg?.ctaInfo || "",
                    ctaData: msg.ctaData,
                    fileName: msg.fileName
                };
            } else {
                return {
                    _id: msg._id,
                    sender: isSender ? "me" : "reciver",
                    text: msg.messageContent,
                    isRead: msg.isRead,
                    user: msg.userId,
                    time: moment(msg?.updatedAt).format("ddd hh:mm A"),
                    type: msg?.messageType,
                    link: msg?.fileUrl || "",
                    fileType: msg?.fileType || "",
                    createdAt: msg?.createdAt,
                    name: msg?.userId?.name,
                    isForwarded: msg.isForwarded,
                    isDeleted: msg.isDeleted,
                    isStared: msg.isStared,
                    replyMessageId: msg.replyMessageId || "",
                    fileName: msg.fileName,
                    pollMessage: msg.pollMessage,


                }
            }
        });
        console.log('modifychat', modifychat);


        const grouped = {};



        modifychat.forEach((msg) => {
            const dateKey = moment(msg.createdAt).format("YYYY-MM-DD"); // for grouping
            if (!grouped[dateKey]) {
                grouped[dateKey] = [];
            }
            grouped[dateKey].push(msg);
        });

        // Build the final array with label
        const data = Object.keys(grouped)
            .sort((a, b) => moment(b).diff(moment(a))) // Optional: latest date first
            .map((date) => {
                const mDate = moment(date);
                let label = mDate.isSame(moment(), "day")
                    ? "Today"
                    : mDate.isSame(moment().subtract(1, "day"), "day")
                        ? "Yesterday"
                        : mDate.format("DD MMM YYYY");

                return {
                    date: label,
                    chats: grouped[date],
                    chatUserId: activeChatsIds[toUser] //|| activeChatsIds[toUser][0]
                };
            });


        if (activeChats.length >= maxChat) {
            if (!activeChats.includes(found)) {
                const newChats = [...activeChats];
                const oldestChat = newChats.shift(); // Remove the oldest chat (first in array)
                newChats.push(found); // Add the new chat
                setActiveChats(newChats);
            }
            setChats(prev => ({ ...prev, [found]: data }));
        } else {
            // Otherwise just add the new chat

            setActiveChats(prev => (
                prev.includes(found) ? prev : [...prev, found]
            ));


            setChats(prev => ({ ...prev, [found]: data }));

            // console.log('[found]: data', found, { [found]: data })
        }

        // Focus on the new chat input after it's rendered
        setTimeout(() => {
            const inputElement = document.getElementById(`chat-input-${found}`);
            if (inputElement) {
                inputElement.focus();
            }
        }, 100);
    }, [messages, activeBotChat, activeUserChat])


    function moveObject(array, id, newIndex) {
        // console.log('array', array);
        // console.log(' id, ', id);
        // console.log(' newIndex', newIndex);

        if (!Array.isArray(array)) {
            console.error("Expected an array, but got:", array);
            return [];
        }


        const elementIndex = array.findIndex((element) => element._id == id);

        if (elementIndex === -1) {
            return array;
        }

        const element = array.splice(elementIndex, 1)[0];
        array.splice(newIndex, 0, element);

        return array;
    }

    // useMemo(() => {
    //     try {
    //         Notification.requestPermission()
    //     } catch (error) {
    //         console.error("Notification.requestPermission()")
    //     }
    // }, [])

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        const authuserId = localStorage.getItem("authUser");

        if (!token) return;

        const apiUrl = `https://chatapi.nte.ai/chat`;
        // const apiUrl = `https://chatstagingapi.nte.ai/chat`;
        // const apiUrl = `http://172.16.5.25:3005/chat`;


        console.log('apiUrl', apiUrl)
        if (!apiUrl) {
            console.error("REACT_APP_API_URL not defined in environment");
            return;
        }

        const newSocket = io(apiUrl, {
            transports: ['websocket'],
            auth: { token },
            // autoConnect: true,
            // reconnection: true,
            // reconnectionAttempts: 5,
            // reconnectionDelay: 1000
        });

        newSocket.on('connect', () => {
            console.log('Connected to socket server with ID:', newSocket.id);



        });


        newSocket.on('disconnect', (reason) => {
            console.log('Socket disconnected:', reason);
            // setSocketConnected(false);
        });

        newSocket.on('receiveMessage', (data) => {
            const authuserId = localStorage.getItem("authUser");
            console.log('Received message:', data);

            // showNotification(data)

            if (!activeChatRef.current.includes(data.fromUserId._id)) {
                setMessageWorkchatAlert(true)
            }


            // Ensure it's an array before calling moveObject
            if (Array.isArray(userChatRef.current)) {
                const newArray = moveObject([...userChatRef.current], data.fromUserId._id, 0); // shallow copy for immutability



                const newData = newArray.map(obj =>
                    obj._id == data.fromUserId._id ? { ...obj, isDeleted: false, messageContent: data.messageContent, messageId: data.messageId, createdAt: data.createdAt, msg: "New", unReadCount: activeChatRef.current.includes(data.fromUserId._id) ? 0 : (obj.unReadCount < 0 ? 1 : obj.unReadCount + 1) } : obj
                );
                // console.log('newDatanewDatanewData', newData)
                userChatRef.current = newData;

                setUserList(newData);
            } else {
                console.error("userChatRef.current is not an array:", userChatRef.current);
            }
            setMessageAlert(false)

            // console.log('activeChatRef.current', activeChatRef.current.includes(data.fromUserId._id), activeChatRef.current, data.fromUserId._id, data.toUserId._id)
            if (!activeChatRef.current.includes(data.fromUserId._id)) return

            messageAlertRef.current = true;
            setMessageAlert(true)
            setMessages((prevMessages) => [data, ...prevMessages]);

            newSocket.emit("readMessage", { user_id: data.fromUserId._id })



        });

        newSocket.on('redMessage', (payload) => {
            // console.log('redMessage received:', payload, activeChatRef.current);
            // alert(payload)

            setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                    activeChatRef.current.includes(payload) ? { ...msg, isRead: true } : msg
                )
            );



        });



        newSocket.on('ownMessage', (data,) => {

            console.log('ownMessage', data)



            if (Array.isArray(userChatRef.current)) {
                const newArray = moveObject([...userChatRef.current], data.toUserId._id, 0); // shallow copy for immutability



                const newData = newArray.map(obj =>
                    obj._id == data.toUserId._id ? { ...obj, messageContent: data.messageContent, messageId: data.messageId, createdAt: data.createdAt, msg: "Read", isDeleted: false, } : obj
                );
                // console.log('newDatanewDatanewData', newData)
                userChatRef.current = newData;

                setUserList(newData);
            } else {
                console.error("userChatRef.current is not an array:", userChatRef.current);
            }
            // console.log('activeChatRef.current', activeChatRef.current.includes(data.toUserId._id), activeChatRef.current, data.toUserId._id)

            if (!activeChatRef.current.includes(data.toUserId._id)) return

            setMessages((prevMessages) => [data, ...prevMessages,]);

        });


        newSocket.on('deletedMessage', (data) => {
            // 
            console.log('deletedMessage response:', data, data.fromUserId, activeChatRef.current._id);
            setUserList((prevUsers) =>
                prevUsers.map((user) =>
                    user.chatUserId === data.chatUserId && data._id === user.messageId
                        ? { ...user, isDeleted: true }
                        : user
                )

            );
            if (!activeChatRef.current.includes(data.fromUserId)) return
            // setMessages((prevMessages) =>
            //     prevMessages.filter((msg) => msg._id !== data._id)
            // );
            setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                    msg._id === data._id ? { ...msg, isDeleted: true } : msg
                )
            );
        })


        newSocket.on('receiveGroupMessage', (data,) => {

            // console.log('receiveGroupMessage', data, data.groupId, activeChatRef, activeChatRef.current.includes(data.groupId)
            //activeGroupChatRef.current.chatUserId

            // )

            if (Array.isArray(userChatRef.current)) {
                const newArray = moveObject([...userChatRef.current], data.groupId, 0); // shallow copy for immutability

                // console.log('newDatanewDatanewDataarr', newArray)


                const newData = newArray.map(obj =>
                    obj.chatUserId == data.groupId ? { ...obj, messageContent: data.messageContent, messageId: data.messageId, createdAt: data.createdAt, isDeleted: false } : obj
                );
                // console.log('newDatanewDatanewData', newData)
                userChatRef.current = newData;

                setUserList(newData);
            } else {
                console.error("newDatanewDatanewData.current is not an array:", userChatRef.current);
            }

            if (data?.userId?._id !== authuserId) {
                // showGroupNotification(data)
            }


            // showGroupNotification(data)


            // if (data.groupId !== activeGroupChatRef.current.chatUserId) return old


            if (!activeChatRef.current.includes(data.groupId)) return
            // setMessages((prevMessages) => [...prevMessages, data]);
            setMessages((prevMessages) => [data, ...prevMessages,]);
            // fetchGroupChatMedia(data.groupId)



        });

        newSocket.on('deleteGroupMessage', (data) => {
            // setMessages((prevMessages) =>
            //     prevMessages.filter((msg) => msg._id !== data.messageId)
            // );

            // setMessagesForSearch((prevMessages) =>
            //     prevMessages.filter((msg) => msg._id !== data.messageId)
            // );
            console.log('deleteGroupMessage', data)
            setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                    msg._id === data.messageId ? { ...msg, isDeleted: true, } : msg
                )
            );

            if (Array.isArray(userChatRef.current)) {
                const newArray = moveObject([...userChatRef.current], data.groupId, 0); // shallow copy for immutability



                const newData = newArray.map(obj =>
                    obj.chatUserId == data.groupId && obj.messageId === data.messageId ? { ...obj, createdAt: new Date(), isDeleted: true, } : obj
                );
                userChatRef.current = newData;

                setUserList(newData);
            } else {
                console.error("newDatanewDatanewData.current is not an array:", userChatRef.current);
            }
        })

        newSocket.on('deleteGroupMessage', (data) => {
            // setMessages((prevMessages) =>
            //     prevMessages.filter((msg) => msg._id !== data.messageId)
            // );

            // setMessagesForSearch((prevMessages) =>
            //     prevMessages.filter((msg) => msg._id !== data.messageId)
            // );
            console.log('deleteGroupMessage', data)
            setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                    msg._id === data.messageId ? { ...msg, isDeleted: true } : msg
                )
            );



            if (Array.isArray(userChatRef.current)) {
                const newArray = moveObject([...userChatRef.current], data.groupId, 0); // shallow copy for immutability

                console.log('newDatanewDatanewDataarr', newArray)


                const newData = newArray.map(obj =>
                    obj.chatUserId == data.groupId ? { ...obj, createdAt: new Date(), isDeleted: true } : obj
                );
                console.log('newDatanewDatanewsadasData', newData)
                userChatRef.current = newData;

                setUserList(newData);
            } else {
                console.error("newDatanewDatanewData.current is not an array:", userChatRef.current);
            }



        })

        newSocket.on('botMessage', (data) => {
            console.log('botMessage response:', data);

            // if (data.toUser !== activeBotRef.current._id) return
            if (Array.isArray(userChatRef.current)) {
                const newArray = moveObject([...userChatRef.current], data.toUser, 0); // shallow copy for immutability

                console.log('newDatanewDatanewDataarr', newArray)


                const newData = newArray.map(obj =>
                    obj._id == data.toUser ? { ...obj, messageContent: data.messageContent, createdAt: data.createdAt } : obj
                );
                console.log('newDatanewDatanewData', newData)
                userChatRef.current = newData;

                setUserList(newData);
            } else {
                console.error("newDatanewDatanewData.current is not an array:", userChatRef.current);
            }

            if (!activeChatRef.current.includes(data.toUser)) return
            setMessages((prevMessages) => [data, ...prevMessages]);
        });


        newSocket.on('initiateBot', (data) => {
            console.log('botMessageinitiateBot response:', data);

            // if (data.toUser !== activeBotRef.current._id) return
            if (Array.isArray(userChatRef.current)) {
                const newArray = moveObject([...userChatRef.current], data.toUser, 0); // shallow copy for immutability

                console.log('newDatanewDatanewDataarr', newArray)


                const newData = newArray.map(obj =>
                    obj._id == data.toUser ? { ...obj } : obj
                );
                console.log('newDatanewDatanewData', newData)
                userChatRef.current = newData;

                setUserList(newData);
            } else {
                console.error("newDatanewDatanewData.current is not an array:", userChatRef.current);
            }
        });

        newSocket.on('pollUpdated', data => {
            console.log('pollUpdated', data, activeChatRef.current, data.groupId);
            if ((activeChatRef.current.includes(data.groupId))) {

                setMessages(prev =>
                    prev.map(msg =>
                        msg._id === data.updatedPoll._id
                            ? { ...msg, pollMessage: data.updatedPoll.pollMessage }
                            : msg,
                    ),
                );
            }
        });

        setSocket(newSocket);

        // Cleanup function
        return () => {
            if (newSocket) {
                newSocket.disconnect();
            }

        };
    }, []);



    const showNotification = (data) => {
        if ('Notification' in window && Notification.permission === 'granted') {
            // new Notification(title, {
            //     body: body,
            //     icon: '../../public/applogo.png' // Optional
            // });
            const notification = new Notification(`New message from ${data?.fromUserId?.name}`, {
                body: data.messageContent,
                icon: '/applogo.png',// fix: no `../../public`

                data: data // optional custom data
            });

            // Handle click
            notification.onclick = function (event) {
                event.preventDefault(); // prevent default behavior
                window.focus();
                const storedList = JSON.parse(localStorage.getItem('userListStore') || '[]');
                // console.log('storedListstoredList', storedList)
                let findUser = storedList.find(x => x._id === notification.data.fromUserId._id)
                if (findUser) {
                    setMessageWorkchatAlert(false)
                    setMinimizedChats([])
                    handleUserClick(findUser);
                    setUpdateUserListNotification(true)

                } else {
                    console.log('User not found in list at the time of click.');
                }



                // window.location.href = notification.data.url || '/';
            };
        }


    };

    const showGroupNotification = (data) => {
        if ('Notification' in window && Notification.permission === 'granted') {

            const notification = new Notification(`New message from ${data.userId.name}`, {
                body: data.messageContent,
                icon: '/applogo.png',// fix: no `../../public`

                data: data // optional custom data
            });

            // Handle click
            notification.onclick = function (event) {
                event.preventDefault(); // prevent default behavior
                window.focus();


                const storedList = JSON.parse(localStorage.getItem('userListStore') || '[]');
                // console.log('storedListstoredList', storedList)
                let findUser = storedList.find(x => x._id === notification.data.userId._id)
                console.log('notification.data.url', findUser)
                if (findUser) {
                    setMessageWorkchatAlert(false)
                    setMinimizedChats([])
                    handleUserClick(findUser);
                    setUpdateUserListNotification(true)

                } else {
                    console.log('User not found in list at the time of click.');
                }



            };
        }


    };

    useEffect(() => {

        const storedList = JSON.parse(localStorage.getItem('userListStore') || '[]');

        if (userList.length == 0 && updateUserListNotification) {
            setUserList(storedList)
            setTimeout(() => {
                setUpdateUserListNotification(false)
            }, 200);
        }



    }, [updateUserListNotification])

    // Store chat state in localStorage when it changes
    useEffect(() => {
        if (typeof window !== 'undefined') {
            localStorage.setItem('activeChats', JSON.stringify(activeChats));
            localStorage.setItem('minimizedChats', JSON.stringify(minimizedChats));
            localStorage.setItem('newMessage', JSON.stringify(chats));
        }
    }, [activeChats, minimizedChats, chats]);

    // Load chat state from localStorage on initial render
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const storedActiveChats = localStorage.getItem('activeChats');
            const storedMinimizedChats = localStorage.getItem('minimizedChats');
            const storedNewMessage = localStorage.getItem('newMessage');

            if (storedActiveChats) setActiveChats(JSON.parse(storedActiveChats));
            if (storedMinimizedChats) setMinimizedChats(JSON.parse(storedMinimizedChats));
            if (storedNewMessage) setNewMessage(JSON.parse(storedNewMessage));
        }
    }, []);

    // Add or focus chat when a user is clicked
    const handleUserClick = (userId) => {
        setChatId('')
        setMessages([])
        setToUser(userId?._id)
        setShowModal(false)
        setMentionedUsers([])
        setChatPageLimit(0); // ✅ Reset page limit

        // ✅ Reset "has more messages" flags
        setHasMoreMessages(true);
        setHasMoreGroupMessages(true);
        hasMoreMessagesRef.current = true;
        hasMoreGroupMessagesRef.current = true;
        if (userId?.type === "group") {
            setActiveUserChat("")

            fetchGroupChatHistory(userId)
            setActiveGroupChat(userId)
            fetchChatGroupInfo(userId?.chatUserId)

        } else if (userId?.type === "bot") {
            // setActiveGroupChat('')
            // setActiveUserChat("")

            setChatId(userId?.chatUserId || "");


            fetchBotChatHistory(userId)
            setActiveBotChat(userId)
            if (userId?.chatUserId) {
                fetchReadBotMessage(userId.chatUserId);
            }
        } else {
            setActiveGroupChat('')

            fetchChatHistory(userId?._id, 0)
            setActiveUserChat(userId)

        }


        socket?.emit("readMessage", { user_id: userId?._id })
        // reset()
        const newData = userChatRef.current.map(obj =>
            obj._id == userId?._id
                ? { ...obj, msg: "Read", unReadCount: 0 }
                : obj
        );

        const isEqual = JSON.stringify(userList) === JSON.stringify(newData); // or use deepEqual if needed

        userChatRef.current = newData;
        // console.log(' ', newData[0])

        if (!isEqual) {
            setUserList(newData);
        }


        // const newData = userList.map(obj =>
        //     obj._id == userId?._id ? { ...obj, msg: "Read" } : obj
        // );
        // console.log('userIduserId', userId)

        // setUserList(newData);
        // If chat is already open, just focus it

    };

    // FIXED: Toggle minimize chat function using functional updates
    const toggleMinimize = (userId) => {
        setMinimizedChats(prevMinimized => {
            if (prevMinimized.includes(userId)) {
                // Unminimize this specific chat
                return prevMinimized.filter(id => id !== userId);
            } else {
                // Minimize this specific chat only
                return [...prevMinimized, userId];
            }
        });
    };

    // Close a chat window with functional updates
    const closeChat = (userId) => {
        setActiveChats(prev => prev.filter(id => id !== userId));
        // Also remove from minimized if it was minimized
        setMinimizedChats(prev => prev.filter(id => id !== userId));
    };
    const autoResizeTextarea = (userId) => {
        const el = textareaRef.current[userId];
        if (el) {
            el.style.height = 'auto'; // Reset height
            el.style.height = `${el.scrollHeight}px`; // Set to scroll height
        }
    };

    const showMentionModal = () => {
        if (groupInputRef.current) {
            const rect = groupInputRef.current.getBoundingClientRect();

            setModalPosition({
                top: rect.top - 250,
                left: rect.left,
                width: rect.width
            });
            setShowModal(true);
        }
    };
    const handleMentionUserSelect = (contact) => {
        const message = newMessage[toUser] || '';
        const atIndex = message.lastIndexOf('@');

        if (atIndex !== -1) {
            const beforeAt = message.substring(0, atIndex);
            const afterMention = message.substring(atIndex + 1);
            const mentionText = `@${contact.userId.name} `;

            const remainingAfterMention = afterMention.split(' ').slice(1).join(' ');
            const updatedMessage = `${beforeAt}${mentionText}${remainingAfterMention ? ' ' + remainingAfterMention : ''}`;

            setNewMessage(prev => ({
                ...prev,
                [toUser]: updatedMessage,
            }));

            setMentionedUsers((prev) => {
                const exists = prev.some((u) => u.userId._id === contact.userId._id);
                return exists ? prev : [...prev, contact];
            });

            setShowModal(false);

            // Focus and resize
            requestAnimationFrame(() => {
                groupInputRef.current?.focus();
                autoResizeTextarea(toUser);
            });
        }
    };


    // Handle message input change
    const handleMessageChange = (userId, value) => {
        setToUser(userId);
        setNewMessage(prev => ({ ...prev, [userId]: value }));

        if (activeGroupChat.type !== 'group') return;

        const atIndex = value.lastIndexOf('@');

        console.log('valueatIndex', value, atIndex)

        if (atIndex !== -1) {
            const afterAt = value.substring(atIndex + 1);

            if (afterAt === '') {
                // Case: ends with @ → show modal with empty query
                setMentionQuery('');
                showMentionModal();
            } else if (!afterAt.includes(' ')) {
                // Case: text after @ is a valid query
                setMentionQuery(afterAt);
                if (!showModal) showMentionModal();
            } else {
                // Case: text after @ contains space → cancel mention
                setShowModal(false);
            }
        } else {
            // No @ → hide mention
            setShowModal(false);
        }

        // Remove users no longer mentioned
        setMentionedUsers((prev) =>
            prev.filter(user => value.includes(`@${user.userId.name}`))
        );
    };

    // Handles input changes for search
    const handleSearchUser = (e) => {
        setSearchVal(e.target.value);

        const value = e.target.value.trim();


        const filteredList = value
            ? chatListSearch.filter(({ name }) =>
                name.toLowerCase().includes(value.toLowerCase())
            )
            : chatListSearch;

        setUserList(filteredList)

        // setActiveChat('')

    };

    // handle conatact search

    const handleContactSearch = (e) => {
        const value = e.target.value.trim();
        setSearchContactVal(value);

        const filteredList = value
            ? ContactListSearch.filter(({ name }) =>
                name.toLowerCase().includes(value.toLowerCase())
            )
            : ContactListSearch;

        setContactList(filteredList);
    };

    // handle forward message
    const handleReplyMessage = (val) => {
        setReplyMessageData(val)
    }



    const fetchInitalFirstMessage = async (val, url) => {
        try {

            let dada = {
                toUser: val
            }
            // console.log('dadadada', dada)
            const response = await axiosInstance.post("chatUser/addChatUser", dada);

            // console.log('hatUser/addChat', response.data)

            if (response.data.status === "success") {
                setActiveChatsIds(prev => {
                    const existing = prev[val] || [];

                    // Avoid adding duplicate
                    if (existing.includes(response.data.chatUserId)) {
                        return prev;
                    }

                    return {
                        ...prev,
                        [val]: [...existing, response.data.chatUserId],
                    };
                });
                handleSocketData(val, response.data.chatUserId, url)
                // setChatId(response.data.chatUserId)

            }


        } catch (error) {
            console.log('d', error)
        }
    }

    const sendMessage = async (userId, url) => {




        const userMessages = activeChatsIds[userId] || [];


        // console.log('userMessages', userMessages)

        // const chatUserIds = [...new Set(userMessages.map(m => m.chatUserId))][0]
        // if (!message?.trim() || url == "") return;


        // return

        if (userMessages.length === 0) {
            await fetchInitalFirstMessage(userId, url);
            // console.log('fetchInitalFirstMessage1')
        } else {
            // console.log('fetchInitalFirstMessagefetchInitalFirstMessage2')

            handleSocketData(userId, userMessages[0], url);
        }






    };

    // handle send group message

    const handleSendGroupMessage = async (userId, url) => {
        const userMessages = activeChatsIds[userId] || [];


        // console.log('userGroupMessages', userMessages)


        handleSocketGroupData(userId, url);
    };


    // Send a new message
    const handleSocketData = (userId, chatId, url) => {

        // const authuserId = localStorage.getItem("authUser"); 68130a267c0685f5e878b854
        // console.log("newMsgnewMsgnewMsg1", userId, chatId, url)
        const authuserId = localStorage.getItem("authUser");



        // console.log("newMsgnewMsgnewMsgchatUserIds", chatId, newMessage, newMessage[userId]?.trim())





        if (newMessage[userId]?.trim()) {
            const newMsg = {

                user_id: userId,
                messageType: fileToUpload ? 'F' : 'M',
                message: newMessage[userId] || "",
                chatUserId: chatId,
                fileType: fileToUpload ? fileToUpload.type : "",
                fileUrl: url ? url : "",
                replyMessageId: replyMessageData._id || "",
                fileName: fileToUpload ? fileToUpload?.name : ""

            };



            // console.log('newMessagenewMessagenewMessagedata', newMsg)
            // return
            socket.emit('sendMessage', newMsg);
            // mockMessages[userId] = [...mockMessages[userId], newMsg];
            setNewMessage(prev => ({ ...prev, [userId]: '' }));
            setFileUrl('')
            handleCancelFileUpload()
            setReplyMessageData('')
            const el = textareaRef.current[userId];
            if (el) {
                el.style.height = 'auto'; // Reset to original height
            }


        } else {
            console.log('sent failed 1', userId)
            console.log('sent failed 2', url)
            console.log('sent failed 3', chatId,)
        }
    };


    const handleSocketGroupData = async (userId, urls) => {
        // console.log("newMsgnewMsgnewMsg1aa", userId, urls, newMessage[userId]?.trim())



        if (newMessage[userId]?.trim()) {
            const newMsg = {

                groupId: activeGroupChat?.chatUserId,
                messageType: fileToUpload ? 'F' : 'M',
                message: newMessage[userId],
                fileType: fileToUpload ? fileToUpload.type : "",
                fileUrl: urls ? urls : "",
                replyMessageId: replyMessageData._id || "",
                mentionedUsers: mentionedUsers.map((usr) => usr?.userId?._id)

            };
            // console.log('newMessagenewMessagenewMessagedata', newMsg)
            // return
            socket.emit('sendGroupMessage', newMsg);
            setNewMessage(prev => ({ ...prev, [activeGroupChat?.chatUserId]: '' }));
            setFileUrl('')
            setReplyMessageData('')
            handleCancelFileUpload()
            setMentionedUsers([])
            const el = textareaRef.current[activeGroupChat?.chatUserId];
            // if (el) {
            //     el.style.height = 'auto'; // Reset to original height
            // }
        }

    };

    const handleAkcBroadcast = async (id) => {
        setClickedAkc(true);
        try {
            const response = await axiosInstance.get(`broadcast/ackMessage/${id}`);
            if (response.data.status === "success") {
                // toast.success(response.data.message)
                setTimeout(() => setClickedAkc(false), 300)
                setMessages((prevMessages) =>
                    prevMessages.map((msg) =>
                        msg._id === id ? { ...msg, isBroadCastAcknowledge: true } : msg
                    )
                );

            }

        } catch (error) {
            console.log('handleDelete', error)
        }
    }



    const handleBotSend = async (userId) => {

        if (!newMessage[userId]?.trim()) return;



        // console.log('handleBotSendchatId', chatId)

        // return

        if (chatId === '') {
            await fetchInitalFirstBotMessage(activeBotChat, userId);
        } else {
            handleSocketBotData(chatId, userId);
        }


    };

    const fetchInitalFirstBotMessage = async (val, userId) => {
        try {

            let dada = {
                botId: val._id
            }
            // console.log('fetchInitalFirstBotMessage', dada)
            // return

            const response = await axiosInstance.post("bot/initiateBot", dada);

            console.log('fetchInitalFirstBotMessage', response.data)

            if (response.data.status === "success") {

                setChatId(response.data.chatUserId)
                setActiveBotChat(response.data)
                fetchBotChatHistory({ _id: response.data.chatUserId })

            }


        } catch (error) {
            console.log('d', error)
        }
    }

    // bot
    const handleSocketBotData = async (id, userId, chatUserId) => {
        try {

            let dada = {
                "botId": id,
                "message": newMessage[userId],
            }


            // return
            const response = await axiosInstance.post("bot/mcpMessage", dada);
            console.log('handleSocketBotData', response.data)


            if (response.data.status === "success") {
                setMessages((prev) => [response.data.messageInfo, ...prev]);
                setUserList((prevUsers) =>
                    prevUsers.map((user) =>
                        user.chatUserId === id
                            ? { ...user, messageContent: response.data.messageInfo.messageContent }
                            : user
                    )

                );


                // fetchReadBotMessage(response.data.messageInfo.toUser)
                // useChatDraftStore.getState().setDraft(id, '');

            }

            setNewMessage(prev => ({ ...prev, [activeBotChat?._id]: '' }));


        } catch (error) {
            console.log('handleSocketBotData', error)

        } finally {
            setNewMessage(prev => ({ ...prev, [activeBotChat?._id]: '' }));

        }


    };


    const handleSocketUpdateGroupPoll = (messageId, optionIndex) => {

        socket.emit('votePoll', {
            messageId: messageId,
            optionIndex: optionIndex,

        });

        console.log('handlePollVote123  ', messageId, optionIndex);


    };



    // Handle enter key press to send message
    const handleKeyDown = (userId, e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendMessage(userId);
        }
    };
    const scrollToMessage = (messageId) => {
        const messageElement = document.getElementById(`message-${messageId}`);
        console.log('messageElement', messageElement)

        if (messageElement && messagesContainerRef.current) {
            messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setHighlightReply(messageId);
            // Remove highlight after 2 seconds
            setTimeout(() => {
                setHighlightReply('');
            }, 2000);
        }
    };


    // user chat delete
    const handleDeleteMessage = (selectDeleteMessageData) => {
        try {

            let payload = {
                id: selectDeleteMessageData._id
            }
            console.log('handleDelete', chatId)
            // return

            socket.emit('deleteMessage', payload)

            setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                    msg._id === selectDeleteMessageData._id ? { ...msg, isDeleted: true } : msg
                )
            );



            const newData = userList.map(obj =>
                // obj.chatUserId == chatId && 
                obj.messageId === selectDeleteMessageData._id ? { ...obj, isDeleted: true } : obj
            );


            console.log('newData', newData)


            userChatRef.current = newData;

            setUserList(newData);
            // setUserListUnchange(newData)
            // setDeleteMessagePop(false)
            // setSelectDeleteMessageData('')


            // setTimeout(() => {
            //     fetchChatHistory(activeUser)

            // }, 500);

        } catch (error) {
            console.log('handleDelete', error)
        }
    }
    // group chat delete



    const handleDeleteGroupMessage = (selectDeleteMessageData) => {
        try {

            let payload = {

                id: selectDeleteMessageData?._id,
                groupId: selectDeleteMessageData?.groupId
            }
            console.log('handleDelete', payload, messages[0])

            // return
            socket.emit('deleteGroupMessage', payload)

            // setDeleteMessagePop(false)
            // setMessages((prevMessages) =>
            //     prevMessages.filter((msg) => msg._id !== selectDeleteMessageData._id)
            // );
            // setMessagesForSearch((prevMessages) =>
            //     prevMessages.filter((msg) => msg._id !== selectDeleteMessageData._id)
            // );

            setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                    msg._id === selectDeleteMessageData._id ? { ...msg, isDeleted: true } : msg
                )
            );

            // setSelectDeleteMessageData('')


            // setTimeout(() => {
            //     fetchGroupChatHistory(selectDeleteMessageData?.groupId)

            // }, 500);

        } catch (error) {
            console.log('handleDelete', error)
        }
    }






    // Scroll to bottom of chat when messages change
    useEffect(() => {
        activeChats.forEach(userId => {
            if (messageEndRef.current[userId] && !minimizedChats.includes(userId)) {
                messageEndRef.current[userId].scrollIntoView({ behavior: 'smooth' });
            }
        });
    }, [activeChats, minimizedChats, messages]);

    useEffect(() => {
        if (fileUrl === "") return

        if (activeGroupChat.type === 'group') {
            handleSendGroupMessage(toUser, fileUrl)

        } else {
            sendMessage(toUser, fileUrl)

        }


    }, [fileUrl])


    // useEffect(() => {


    //     // if (searchVal?.trim() === "") return

    //     const delayDebounce = setTimeout(() => {
    //         fetchSearchChatUserList();
    //     }, 500);

    //     return () => clearTimeout(delayDebounce);
    // }, [searchVal]);


    const contextValue = {
        activeChats,
        minimizedChats,
        newMessage,
        messageEndRef,
        handleUserClick,
        toggleMinimize,
        closeChat,
        handleMessageChange,
        sendMessage,
        handleKeyDown,
        minimizedContact, setMinimizedContact,
        activeTab, setActiveTab,
        handleSwitchTab,
        fetchChatUserList,
        userList,
        contactList,
        maxChat, setMaxChat,
        messages, setMessages,
        chats, setChats,
        messageAlert, setMessageAlert,
        setToUser,
        fetchGroupChatHistory,
        handleAttachmentClick,
        fileInputRef,
        handleFileSelect,
        showPreviewDialog, isImageFile, handleCancelFileUpload, formatFileSize,
        fileToUpload,
        fetchUploadFileApi,
        isDragging,
        handleDragOver, handleDragEnter, handleDragLeave, handleDrop,
        dropAreaRef,
        textareaRef,
        messageWorkchatAlert,
        setMessageWorkchatAlert,
        messageWorkchatUserAlert, setMessageWorkchatUserAlert,
        fetchChatUserList,
        handleSendGroupMessage,
        searchContactVal,
        handleContactSearch,
        searchVal,
        handleSearchUser,
        replyMessageData, setReplyMessageData,
        handleReplyMessage,
        showModal,
        modalRef, setShowModal,
        groupInputRef,
        filteredMentionGroupMembers,
        handleMentionUserSelect,
        autoResizeTextarea,
        messagesContainerRef, scrollToMessage, setHighlightReply, highlightReply,
        handleDeleteMessage,
        handleDeleteGroupMessage,
        activeChatOptions, setActiveChatOptions, handleChatFilter,
        handleBotSend,
        setOpenChatUserId,
        isDisableMcpInput,
        chatPageLimit, setChatPageLimit,
        activeGroupChat,
        fetchChatHistory,
        activeUserChat,
        hasMoreMessagesRef,
        activeBotChat,
        fetchBotChatHistory,
        handleSocketUpdateGroupPoll,
        handleAkcBroadcast,
        isUploadFileLoading

    };

    return (
        <ChatContext.Provider value={contextValue}>
            {children}
        </ChatContext.Provider>
    );
}